// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-wrap[data-v-09c83efa]{min-height:100vh}.layout-wrap .layout-content[data-v-09c83efa]{min-height:calc(100vh - 160px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
